<div class='wrapperPayoutFormat wrapperPayoutFormat--{{(payoutFormat|strCase:"camel")}}'>
  {{payoutFormat}}
  <meSvg *ngIf='(payoutFormat|strCase:"camel") == "notchPay"' svgName='lightning_gold&20'></meSvg>
</div>